import { NgModule, ModuleWithProviders } from '@angular/core';
import { DynamicHTMLOptions } from './dynamic-html.options';
import { DynamicHTMLRenderer } from './dynamic-html.renderer';
import { SharedModule } from '../../shared.module';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [ CommonModule, SharedModule ],
  declarations: [],
  exports: []
})
export class DynamicHTMLModule {
  static forRoot(options: DynamicHTMLOptions): ModuleWithProviders<DynamicHTMLModule> {
    return {
      ngModule: DynamicHTMLModule,
      providers: [
        DynamicHTMLRenderer,
        { provide: DynamicHTMLOptions, useValue: options },
        // { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: options.components, multi: true },
      ]
    };
  }
}
